module.exports = __webpack_public_path__ + "static/media/BCFS_DRTS.83a0d94d.jpg";